import { ReactElement } from 'react'
import styled from 'styled-components'

import { CAREERS_ROUTE } from '@/utils/enroutes'

import { LinkCard } from '@/components/elements/LinkCard'
import { LinkCardList } from '@/components/elements/LinkCardList'
import { ImageTitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'

export const CareersPage = () => {
  return (
    <CareersMain>
      <LinkCardList>
        {CAREERS_ROUTE.subdirectories.map(
          ({ imagePath, path, name, ...rest }) => (
            <LinkCard
              imgPath={imagePath}
              key={path}
              link={path}
              title={name}
              {...rest}
            />
          )
        )}
      </LinkCardList>
    </CareersMain>
  )
}
CareersPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'HOME', path: '/en/' },
    { name: 'Careers', path: '' }, 
  ]

  return (
    <>
      <Head
        title="Careers"
        description="The recruitment information for TRIAL Holdings, Inc. is available. The TRIAL Group is actively seeking individuals who, with technology and human expertise, aim to transform the world of real commerce."
        ogp={{ url: 'en/careers/' }}
      />
      <ImageTitleLayout
        title=""
        subTitle=""
        enTitle="Careers"
        imgUrl="/images/top-careers.webp"
        breadCrumbs={breadCrumbs}
        isRequiredBackground={false}
      >
        {page}
      </ImageTitleLayout>
    </>
  )
}

const CareersMain = styled.div`
  width: 1040px;
  margin: 0 auto;
  padding: 96px 0 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 80px;
  }
`
